import React from 'react';
import PropTypes from 'prop-types';

import {Box, Typography, Chip} from 'views/components';
import {Translate} from 'views/module';

const CaregiverBox = (props) => {
  const {data} = props;

  return (
    <Box style={{background: 'white', borderRadius: '1rem', boxShadow: '0 1px 6px rgba(0,0,0,0.1)', padding: '1rem', position: 'relative'}}>
      <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '0.5rem'}}>
        <Typography variant="h6">
          <Translate expression="profile.CaregiverBox.Title" />
        </Typography>
      </Box>

      {/* Caregiver Personality */}
      <Typography variant="subtitle2" style={{marginTop: 0}}>
        <Translate expression="profile.CaregiverBox.CaregiverPersonality" />
      </Typography>
      {
        data.caregiverPersonality && (
          <Box sx={{padding: '0.5rem 0', marginBottom: '0.5rem'}}>
            <Typography style={{whiteSpace: 'pre-line', color: '#374151', fontSize: 14}}>{data.caregiverPersonality}</Typography>
          </Box>
        )
      }
      {
        !data.caregiverPersonality && (
          <Typography style={{color: '#71717A', fontStyle: 'italic', fontSize: '0.875rem', padding: '0.5rem 0', marginBottom: '0.5rem'}}>
            <Translate expression="profile.CaregiverBox.CaregiverPersonalityPlaceholder" />
          </Typography>
        )
      }

      {/* Skills Required */}
      <Typography variant="subtitle2" style={{marginTop: '0.5rem'}}>
        <Translate expression="profile.CaregiverBox.Skills" />
      </Typography>
      {
        data.skills && (
          <Box sx={{
            display: 'flex',
            gap: '0.5rem',
            marginTop: '0.25rem',
            color: '#5b8ecb',
            flexWrap: 'wrap',
            alignItems: 'flex-start',
            wordBreak: 'break-word',
          }}>
            {
              data.skills.map((skill, idx) => (
                <Chip
                  key={idx}
                  label={skill}
                  size="small"
                  sx={{color: '#3060d9', background: '#e6f0fa', marginBottom: '0.25rem'}}
                />
              ))
            }
          </Box>
        )
      }
      {
        !data.skills && (
          <Typography style={{color: '#71717A', fontStyle: 'italic', fontSize: '0.875rem', marginTop: '0.25rem'}}>
            <Translate expression="profile.CaregiverBox.SkillsPlaceholder" />
          </Typography>
        )
      }
    </Box>
  );
};

CaregiverBox.propTypes = {
  data: PropTypes.shape({
    caregiverPersonality: PropTypes.string,
    skills: PropTypes.arrayOf(PropTypes.string),
  }).isRequired,
};

export default CaregiverBox;
